import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withIntl } from 'ha/i18n';
import { withRouter } from 'react-router';

import {
  getCollectionFilter,
  getlangURLListState,
  getNumberOfListings,
  getCityLocalized,
  getCountryLocalized,
  getAdvertiserName,
} from '../selectors';
import SearchPageCrawl from '../components/SearchPageCrawl';

const enhance = compose(
  withRouter,
  connect(state => ({
    canonicalCollection: getCollectionFilter(state),
    cityLocalized: getCityLocalized(state),
    countryLocalized: getCountryLocalized(state),
    langUrlList: getlangURLListState(state),
    numberOfListings: getNumberOfListings(state),
    advertiserName: getAdvertiserName(state),
  })),
  withIntl,
);

export default enhance(SearchPageCrawl);
